module.exports = __webpack_public_path__ + "static/media/img-made-thumb@3x.ce72cda1.png";